module.exports = __webpack_public_path__ + "img/login-right-side.3a3b556c.png";